module.exports = __webpack_public_path__ + "img/pending.55b66e9b.svg";